module.exports = __webpack_public_path__ + "img/0706-音乐制作-下-02.4e091252.png";